// reducer.js
import { SET_EXTENDED_ANALYSIS_RESULTS } from './actions';

const initialState = {
  extendedAnalysisResults: null
};

const extendedAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EXTENDED_ANALYSIS_RESULTS:
      return {
        ...state,
        extendedAnalysisResults: action.payload
      };
    default:
      return state;
  }
};

export default extendedAnalysisReducer;
